// VINIFIKANT-PATCH: Epikur-medlemskab (data-vink-max1) - tilstand og knaptekst følger kurven.
// Etiketterne ligger som data-attributter på formen (data-vink-label-ny / data-vink-label-i-kurv).
window.vinkSyncMax1 = function (iKurv) {
  document.querySelectorAll('form[data-vink-max1]').forEach((form) => {
    form.dataset.vinkMax1 = iKurv ? 'i-kurv' : 'ny';
    const knap = form.querySelector('[type="submit"]');
    const etiket = knap && knap.querySelector('span');
    const tekst = iKurv ? form.dataset.vinkLabelIKurv : form.dataset.vinkLabelNy;
    if (etiket && tekst && !knap.disabled) etiket.textContent = tekst;
  });
};

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      // VINIFIKANT-PATCH: Epikur-medlemskab, højst 1 i kurven. Tjek kurven live, så fjernelse nulstiller tilstanden.
      if (this.form.hasAttribute('data-vink-max1') && this.form.dataset.vinkMax1 === 'i-kurv' && !this.vinkTjekker) {
        this.vinkTjekker = true;
        const varId = parseInt(this.form.querySelector('[name=id]').value, 10);
        fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((kurv) => {
            const iKurv = kurv.items.some((i) => i.variant_id === varId);
            window.vinkSyncMax1(iKurv);
            if (iKurv) { if (this.cart && this.cart.open) this.cart.open(); }
            else this.form.requestSubmit();
          })
          .catch(() => { if (this.cart && this.cart.open) this.cart.open(); })
          .finally(() => { this.vinkTjekker = false; });
        return;
      }

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          if (this.form.hasAttribute('data-vink-max1')) window.vinkSyncMax1(true);
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
